import React, { useState, useEffect } from "react"
import Layout from "../components/Layout";
import WorksFooter from "../components/WorksFooter";
import MobWorksFooter from "../components/MobWorksFooter";
import Carrousel from "../components/Carrousel";
import Mosaic from "../components/Mosaic";
import * as styles from "../styles/works.module.css";
import BackVideo3 from "../../static/videos/vichy.webm";
import BackVideo9 from "../../static/videos/bandoleiro.webm";
import BackVideo1 from "../../static/videos/mondelez.webm";
import BackVideo2 from "../../static/videos/samsunngs20.webm";
import BackVideo5 from "../../static/videos/rochepossay.webm";
import BackVideo6 from "../../static/videos/huawei.webm";
import BackVideo4 from "../../static/videos/cicaplast.webm";
import BackVideo8 from "../../static/videos/jetsmart.webm";
import BackVideo7 from "../../static/videos/toyota.webm";
import BackVideo0 from "../../static/videos/playstation.webm";

function Works() {
  const [isMosaic, setIsMosaic] = useState(false)
  const [carouselClass, setCarouselClass] = useState("wf-liks")
  const [mosaicClass, setMosaicClass] = useState("wf-liks")
  const [layourBgColor, setLayoutBgColor] = useState("#000000")
  const [footerMailStyle, setFooterMailStyle] = useState("mail-footer-c")
  const [slashColor, setSlashColor] = useState("wf-slash")
  const [videoIndex, setVideoIndex] = useState(0)

  function goToSlideWork(id) {
    setIsMosaic(false);
  }

  const handleChangeMosaic = value => setIsMosaic(value)

  const videos = [
    BackVideo0,
    BackVideo1,
    BackVideo2,
    BackVideo3,
    BackVideo4,
    BackVideo5,
    BackVideo6,
    BackVideo7,
    BackVideo8,
    BackVideo9,
  ];

  useEffect(() => {
    setCarouselClass(isMosaic ? "wf-liks__m" : "wf-liks wf-links-active")
    setMosaicClass(isMosaic ? "wf-liks__m wf-links__m-active" : "wf-liks")
    setLayoutBgColor(isMosaic ? "#F4D200" : "transparent")
    setFooterMailStyle(isMosaic ? "mail-footer-m" : "mail-footer-c")
    setSlashColor(isMosaic ? "wf-slash__m" : "wf-slash")
  }, [isMosaic])

  return (
    <Layout contentStyle="content" bgcolor={layourBgColor} mosaic={isMosaic}>
      {videos.map((video, index) => {
        return (
          <video key={index} autoPlay muted loop className={`${styles.backVideo} ${videoIndex === index && styles.backVideoActive}`}>
            <source src={video} type="video/mp4" />
          </video>
        )
      })
      }

      {!isMosaic && <Carrousel setVideoIndex={setVideoIndex} />}
      {isMosaic && <Mosaic goToSlideWork={goToSlideWork} setIsMosaic={setIsMosaic} />}
      <WorksFooter
        carouselStyle={carouselClass}
        mosaicStyle={mosaicClass}
        handleChangeMosaic={handleChangeMosaic}
        mailStyle={footerMailStyle}
        slashStyle={slashColor}
      />
      <MobWorksFooter
        carouselStyle={carouselClass}
        mosaicStyle={mosaicClass}
        handleChangeMosaic={handleChangeMosaic}
        mailStyle={footerMailStyle}
        isMosaic={isMosaic}
      />
    </Layout>
  )
}

export default Works
